module.exports = __webpack_public_path__ + "p5_img1.jpg?5cc469d139a90f62ada6dd2a7c8d9825";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img1.jpg
// module id = 123
// module chunks = 0